export default {
  accepted_title: {
    en: 'Proposal has been accepted!',
    no: 'Tilbudet er akseptert!',
    sv: 'Förslaget har accepterats!',
    da: 'Forslaget er accepteret!',
  },
  accepted_details: {
    en: 'The proposal (v{version}, id{versionId}) has been accepted.',
    no: 'Tilbudet (v{version}, id{versionId}) er akseptert.',
    sv: 'Förslaget (v{version}, id{versionId}) har accepterats.',
    da: 'Forslaget (v{version}, id{versionId}) er accepteret.',
  },
  accepted_other_version_details: {
    en: 'A different version (v{version}, id{versionId}) of this proposal has been accepted.',
    no: 'En annen versjon (v{version}, id{versionId}) av dette tilbudet er akseptert.',
    sv: 'En annan version (v{version}, id{versionId}) av detta förslag har accepterats.',
    da: 'En anden version (v{version}, id{versionId}) af dette forslag er blevet accepteret.',
  },
  accepted_current_viewing: {
    en: "You're currently looking at v{version} (id{versionId}).",
    no: 'Du ser nå på v{version} (id{versionId}).',
    sv: 'Du tittar just nu på v{version} (id{versionId}).',
    da: 'Du kigger i øjeblikket på v{version} (id{versionId}).',
  },
  waiting_email_verification: {
    en: 'Waiting for e-mail verification.',
    no: 'Venter på e-postbekreftelse.',
    sv: 'Väntar på e-postverifiering.',
    da: 'Venter på e-mailbekræftelse.',
  },
  didnt_receive_email: {
    en: "Didn't receive the e-mail?",
    no: 'Mottok du ikke e-posten?',
    sv: 'Fick du inte e‑postmeddelandet?',
    da: 'Modtog du ikke e‑mailen?',
  },
  try_again_link: {
    en: 'Try filling out the form again',
    no: 'Prøv å fylle ut skjemaet på nytt',
    sv: 'Försök fylla i formuläret igen',
    da: 'Prøv at udfylde formularen igen',
  },
  thank_you_title: {
    en: 'Thank you!',
    no: 'Takk!',
    sv: 'Tack!',
    da: 'Tak!',
  },
  email_sent_verification: {
    en: 'An email has been sent with a verification link.',
    no: 'En e‑post med bekreftelseslenke er sendt.',
    sv: 'Ett e‑postmeddelande har skickats med en verifieringslänk.',
    da: 'En e‑mail er sendt med et bekræftelseslink.',
  },
  accept_proposal_title: {
    en: 'Accept proposal',
    no: 'Aksepter tilbud',
    sv: 'Acceptera förslag',
    da: 'Accepter forslag',
  },
  accept_proposal_action: {
    en: 'Accept proposal',
    no: 'Aksepter tilbud',
    sv: 'Acceptera förslag',
    da: 'Accepter forslag',
  },
  accept_proposal_intro_line1: {
    en: 'Please review these details before accepting the proposal.',
    no: 'Vennligst se over detaljene før du aksepterer tilbudet.',
    sv: 'Granska dessa uppgifter innan du accepterar förslaget.',
    da: 'Gennemgå venligst disse detaljer, før du accepterer forslaget.',
  },
  accept_proposal_intro_line2: {
    en: 'When accepting, you will receive an e-mail with a link to verify it is you who is accepting the proposal.',
    no: 'Når du aksepterer, mottar du en e‑post med lenke for å verifisere at det er du som aksepterer tilbudet.',
    sv: 'När du accepterar får du ett e‑postmeddelande med en länk för att verifiera att det är du som accepterar förslaget.',
    da: 'Når du accepterer, modtager du en e‑mail med et link til at bekræfte, at det er dig, der accepterer forslaget.',
  },
  you_label: {
    en: 'You',
    no: 'Du',
    sv: 'Du',
    da: 'Dig',
  },
  proposal_label: {
    en: 'Proposal',
    no: 'Tilbud',
    sv: 'Förslag',
    da: 'Forslag',
  },
  travel_date_label: {
    en: 'Travel date (from–to)',
    no: 'Reisedato (fra–til)',
    sv: 'Resedatum (från–till)',
    da: 'Rejsedato (fra–til)',
  },
  number_of_travelers_label: {
    en: 'Number of travelers',
    no: 'Antall reisende',
    sv: 'Antal resenärer',
    da: 'Antal rejsende',
  },
  amount_per_pax_label: {
    en: 'Amount per pax',
    no: 'Beløp per person',
    sv: 'Belopp per person',
    da: 'Beløb pr. person',
  },
  your_full_name_label: {
    en: 'Your full name',
    no: 'Ditt fulle navn',
    sv: 'Ditt fullständiga namn',
    da: 'Dit fulde navn',
  },
  your_email_label: {
    en: 'Your e-mail',
    no: 'Din e‑post',
    sv: 'Din e‑post',
    da: 'Din e‑mail',
  },
  terms_and_conditions_label: {
    en: 'Terms and conditions',
    no: 'Vilkår',
    sv: 'Villkor',
    da: 'Vilkår',
  },
  terms_unavailable_title: {
    en: 'Terms and conditions unavailable, please give notice to your tour operator',
    no: 'Vilkår er ikke tilgjengelige, gi beskjed til turoperatøren',
    sv: 'Villkor är inte tillgängliga, meddela din researrangör',
    da: 'Vilkår er ikke tilgængelige, giv besked til din rejsearrangør',
  },
  accept_terms_title: {
    en: 'Accept terms and conditions',
    no: 'Godta vilkår',
    sv: 'Acceptera villkor',
    da: 'Accepter vilkår',
  },
  i_accept_prefix: {
    en: 'I accept the',
    no: 'Jeg aksepterer',
    sv: 'Jag accepterar',
    da: 'Jeg accepterer',
  },
  terms_and_conditions_link_text: {
    en: 'terms and conditions',
    no: 'vilkårene',
    sv: 'villkoren',
    da: 'vilkårene',
  },
  cannot_accept_without_terms_title: {
    en: 'You cannot accept the proposal without accepting the terms and conditions',
    no: 'Du kan ikke akseptere tilbudet uten å godta vilkårene',
    sv: 'Du kan inte acceptera förslaget utan att acceptera villkoren',
    da: 'Du kan ikke acceptere forslaget uden at acceptere vilkårene',
  },
  submit_form_title: {
    en: 'Submit form',
    no: 'Send inn skjema',
    sv: 'Skicka in formulär',
    da: 'Indsend formular',
  },
  prices_heading_placeholder: {
    en: 'Fill in prices heading..',
    no: 'Fyll inn prisoverskrift..',
    sv: 'Fyll i prisrubrik..',
    da: 'Udfyld prisoverskrift..',
  },
  prices_cta_placeholder: {
    en: 'Fill in prices call to action..',
    no: 'Fyll inn handlingsknapp for priser..',
    sv: 'Fyll i uppmaning för priser..',
    da: 'Udfyld opfordring til handling for priser..',
  },
  prices_heading_default: {
    en: 'Price offer',
    no: 'Pristilbud',
    sv: 'Prisförslag',
    da: 'Pristilbud',
  },
  prices_cta_default: {
    en: 'Accept the proposal here',
    no: 'Gi aksept på tilbudet her',
    sv: 'Acceptera förslaget här',
    da: 'Accepter forslaget her',
  },
  greeting_kind_regards: {
    en: 'Kind regards',
    no: 'Med vennlig hilsen',
    sv: 'Med vänliga hälsningar',
    da: 'Med venlig hilsen',
  },
  delivered_by_label: {
    en: 'Offer delivered by:',
    no: 'Tilbudet levert av:',
    sv: 'Förslaget levererat av:',
    da: 'Forslaget leveret af:',
  },
  org_no_label: {
    en: 'org.no',
    no: 'org.nr',
    sv: 'org.nr',
    da: 'CVR',
  },
  see_terms_link: {
    en: 'See terms for the trip',
    no: 'Se vilkår for turen',
    sv: 'Se villkor för resan',
    da: 'Se vilkår for rejsen',
  },
  privacy_and_cookies_link: {
    en: 'Privacy and Cookies',
    no: 'Personvern og Cookies',
    sv: 'Integritet och cookies',
    da: 'Privatliv og cookies',
  },
  modal_warning_title: {
    en: 'Warning!',
    no: 'Advarsel!',
    sv: 'Varning!',
    da: 'Advarsel!',
  },
  modal_warning_terms_unavailable_line1: {
    en: 'It is not possible to accept the proposal version as terms are not uploaded.',
    no: 'Det er ikke mulig å akseptere tilbudsversjonen fordi vilkår ikke er lastet opp.',
    sv: 'Det går inte att acceptera förslagsversionen eftersom villkor inte är uppladdade.',
    da: 'Det er ikke muligt at acceptere forslagsversionen, da vilkår ikke er uploadet.',
  },
  modal_warning_terms_unavailable_line2: {
    en: 'Please go to Team settings and upload terms to the brand you have selected for the proposal.',
    no: 'Gå til teaminnstillinger og last opp vilkår til merket du har valgt for tilbudet.',
    sv: 'Gå till teaminställningar och ladda upp villkor till det varumärke du har valt för förslaget.',
    da: 'Gå til teama indstillinger og upload vilkår til det brand, du har valgt til forslaget.',
  },
  modal_note_title: {
    en: 'Note!',
    no: 'Merk!',
    sv: 'Observera!',
    da: 'Bemærk!',
  },
  modal_note_line1: {
    en: 'It is not possible to accept the proposal in create proposal.',
    no: 'Det er ikke mulig å akseptere tilbudet i opprett tilbud.',
    sv: 'Det går inte att acceptera förslaget i skapa förslag.',
    da: 'Det er ikke muligt at acceptere forslaget i opret forslag.',
  },
  modal_note_line2: {
    en: 'Please open one of the proposal versions and accept the proposal there.',
    no: 'Åpne en av tilbudsversjonene og aksepter tilbudet der.',
    sv: 'Öppna en av förslagsversionerna och acceptera förslaget där.',
    da: 'Åbn en af forslagsversionerne og accepter forslaget der.',
  },
  close_button: {
    en: 'Close',
    no: 'Lukk',
    sv: 'Stäng',
    da: 'Luk',
  },
};
